/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Galleryprevious1Inputs */

const en_galleryprevious1 = /** @type {(inputs: Galleryprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous image`)
};

const de_galleryprevious1 = /** @type {(inputs: Galleryprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Bild`)
};

/**
* | output |
* | --- |
* | "Previous image" |
*
* @param {Galleryprevious1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const galleryprevious1 = /** @type {((inputs?: Galleryprevious1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Galleryprevious1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_galleryprevious1(inputs)
	return de_galleryprevious1(inputs)
});
export { galleryprevious1 as "galleryPrevious" }